/**
 * Returns singular or plural based on count
 * @param {*} one
 * @param {*} other
 * @param {*} count number of items
 */
export default function pluralize(
  one: $TSFixMe,
  other: $TSFixMe,
  count: $TSFixMe,
) {
  return count === 1 ? one : other;
}
